import { icon } from "../icons";
import { CATEGORIES } from "../categories";

/** Custom dropdown multi-select per le categorie: trigger compatto (collassato)
 * + panel con icona, label e checkbox per ogni categoria. Niente `<select
 * multiple>` nativo, che resta sempre esploso e senza icone/checkbox. Usato sia
 * nel filtro sia nei form di creazione/modifica foto (id diverso per istanza). */
export function categorySelectMarkup(id: string, selected: string[]): string {
  const options = CATEGORIES.map((c) => {
    const on = selected.includes(c.value);
    return `<button type="button" class="select__option${on ? " is-selected" : ""}" role="option" aria-selected="${on}" data-cat="${c.value}">
        <span class="select__check" aria-hidden="true">${icon("check", { size: 14 })}</span>
        ${icon(c.icon, { size: 18, cls: "select__option-icon" })}
        <span class="select__option-label">${c.label}</span>
      </button>`;
  }).join("");
  return `<div class="select" id="${id}" data-open="false">
      <button type="button" class="select__trigger" aria-haspopup="listbox" aria-expanded="false">
        <span class="select__value" data-placeholder="Tutte le categorie"></span>
        ${icon("expand_more", { size: 20, cls: "select__chevron" })}
      </button>
      <div class="select__panel" role="listbox" aria-multiselectable="true" aria-label="Categorie" hidden>
        ${options}
      </div>
    </div>`;
}

/** Markup del blocco di posizionamento (upload + edit): ricerca luogo esplicita,
 * "Usa posizione attuale", coordinate correnti. Il click/drag sulla mappa è
 * cablato da `createLocationPicker`, non qui. */
export function locationPickerMarkup(mapTapHint = true): string {
  // `mapTapHint`: in upload (sheet fullscreen) il tap sulla mappa è sospeso, la
  // posizione arriva da EXIF/ricerca/posizione attuale → microcopy diversa.
  const hint = mapTapHint
    ? `<p class="form__hint">Tocca la mappa per posizionare il pin (trascinabile).</p>`
    : `<p class="form__hint">La posizione arriva dai dati della foto, dalla ricerca o da «Usa la posizione attuale».</p>`;
  return `
    <div class="loc-picker">
      <div class="loc-search">
        <input type="text" class="field__input loc-search-input" placeholder="Cerca un luogo"
               autocomplete="off" aria-label="Cerca un luogo" />
        <button type="button" class="btn btn--outlined loc-search-btn">${icon("search", { size: 18 })}<span class="spinner" hidden></span> Cerca</button>
        <button type="button" class="icon-btn loc-geo-btn" title="Usa la posizione attuale" aria-label="Usa la posizione attuale">${icon("my_location", { size: 20 })}<span class="spinner" hidden></span></button>
      </div>
      <ul class="loc-results" aria-label="Risultati ricerca luogo" hidden></ul>
      <p class="loc-msg loc-msg--search form__hint" role="status" aria-live="polite"></p>
      <p class="loc-msg loc-msg--geo form__hint" role="status" aria-live="polite"></p>
      <span class="form__coord loc-coord"></span>
      ${hint}
    </div>`;
}
